/**
 * v3.21 朋友圈红点：已读时间戳（LS `mesh_circle_seen_ts`）。
 *
 * 新好友动态 = 好友（联系人 did + 关注 did）发布的、时间晚于已读时间戳的帖子。
 * 进入朋友圈页时调用 `markCircleSeen()` 清零；入口（发现页卡片 / 我的页按钮）显示未读数 badge。
 */

const SEEN_KEY = 'mesh_circle_seen_ts';
const COVER_KEY = 'mesh_circle_cover';

export interface CircleCover {
  emoji: string;
  bg: string;
}

export const CIRCLE_COVER_EMOJIS = ['🌅', '🏔', '🌊', '🌙', '🏙', '🌸', '🍃', '☁️', '🎈', '🌟', '🔥', '❄️'] as const;
export const CIRCLE_COVER_BGS = [
  'linear-gradient(135deg,#1e3a5f,#4a90d9)',
  'linear-gradient(135deg,#3a1e5f,#9b59b6)',
  'linear-gradient(135deg,#0f4c3a,#27ae60)',
  'linear-gradient(135deg,#5f1e1e,#e74c3c)',
  'linear-gradient(135deg,#5f4a1e,#f39c12)',
  'linear-gradient(135deg,#1e3a5f,#16a085)',
] as const;

export function getCircleSeen(): number {
  try {
    const raw = window.localStorage.getItem(SEEN_KEY);
    const n = raw ? Number(raw) : 0;
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
}

export function markCircleSeen(ts = Date.now()): void {
  try {
    window.localStorage.setItem(SEEN_KEY, String(ts));
  } catch {
    /* 存储不可用忽略 */
  }
}

export function loadCircleCover(): CircleCover | null {
  try {
    const raw = window.localStorage.getItem(COVER_KEY);
    const c = raw ? (JSON.parse(raw) as CircleCover) : null;
    return c && typeof c.emoji === 'string' && typeof c.bg === 'string' ? c : null;
  } catch {
    return null;
  }
}

export function saveCircleCover(cover: CircleCover): void {
  try {
    window.localStorage.setItem(COVER_KEY, JSON.stringify(cover));
  } catch {
    /* 存储不可用忽略 */
  }
}

/** 未读好友动态数：好友（含自己）发布的帖子中 ts > 已读时间戳 的数量。 */
export function unseenCircleCount(
  posts: { authorDid?: string; ts: number }[],
  friendDids: Set<string>,
): number {
  const seen = getCircleSeen();
  return posts.filter((p) => {
    const author = (typeof p.authorDid === 'string' ? p.authorDid : '').toLowerCase();
    return author !== '' && friendDids.has(author) && p.ts > seen;
  }).length;
}
